/**
 * Copyright © 2026 OwnersTable Inc. All rights reserved.
 * This source code is proprietary and confidential.
 * Unauthorized copying or distribution is strictly prohibited.
 */

import { useCallback, useState } from "react";

// Held by the page so its Reset can clear the loaded query.
export const useSavedQueryState = () => {
  const [loadedQuery, setLoadedQuery] = useState(null);
  // The loaded query's filters as applied or last saved, to tell when the page has changed them.
  const [loadedFilters, setLoadedFilters] = useState(null);
  const clearLoadedQuery = useCallback(() => {
    setLoadedQuery(null);
    setLoadedFilters(null);
  }, []);

  return { loadedQuery, setLoadedQuery, loadedFilters, setLoadedFilters, clearLoadedQuery };
};

// Labels are left out so a lookup that loads later doesn't count as a change.
export const toComparableFilters = (adapter, filters) => JSON.stringify(adapter.serialize(filters, {}));

export const isLoadedQueryModified = (adapter, filters, state) =>
  Boolean(state.loadedQuery) && toComparableFilters(adapter, filters) !== state.loadedFilters;

export const toLoadedQuery = (record) => ({
  id: record.id,
  name: record.name,
  description: record.description || "",
});

// Serialized JSON is compared, so dayjs instances and label lookups don't cause false changes.
export const hasChangedFromDefaults = (adapter, savedFilters) =>
  JSON.stringify(savedFilters) !== JSON.stringify(adapter.serialize(adapter.defaults(), {}));

export const normalizeQueryName = (name) => `${name || ""}`.replace(/\s+/g, " ").trim();
